import { z } from "zod";
import { BaseEvent } from "./base";
const PurgeResource = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("paywall"),
        paywallId: z.number(),
        locales: z.array(z.string()).optional()
    }),
    z.object({
        type: z.literal("static_config"),
        applicationId: z.number()
    })
]);
export const CachePurge_Request = BaseEvent.extend({
    name: z.literal("events.superwall.com.cache.v1.CachePurge_Request"),
    event: z.object({
        resource: PurgeResource,
        paths: z.array(z.string())
    })
});
